
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    Typography
} from "@mui/material";
import theme from "../../../../theme/Theme";
import { TaskConfig } from "../../../../types/cqa";
import CheckboxGroup from "../../../atoms/checkboxes/checkboxes";
import { attributeCheckboxes as attributeCheckboxesDefault, codeCheckboxes, CodeCheckboxField } from "../defaultCQAConfig";
import "../ruleCommonSection.css";
import { ASTERISK_ELEMENT, SELECTION_COLOR } from "../ruleCommonStyleBlocks";

interface Props {
    attributeCheckboxes?: CodeCheckboxField[];
    cqaConfig: TaskConfig;
    spanAnnotationEnabled: boolean;
    setCqaConfig: (value: React.SetStateAction<TaskConfig>) => void;
    selectedRubricId?: number | null;
}

export const Tasks = ({
    attributeCheckboxes = attributeCheckboxesDefault,
    cqaConfig,
    spanAnnotationEnabled,
    setCqaConfig,
    selectedRubricId = null
}: Props): JSX.Element => {
    const onChangeCaseEvaluation = (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
        const newConfig = { ...cqaConfig };
        newConfig["caseEvaluationLevel"] = value === "case" ? true : false;
        setCqaConfig(newConfig);
    }

    return (
        <Box>
            {/* Container Title */}
            <Box className="setting_section_title_container">
                <Box className="setting_section_text_container" style={{ width: "53px" }}>
                    <span className="setting_section_text">
                        Tasks
                    </span>
                </Box>
            </Box>
            {/* main area */}
            <Box
                id="tasks-config"
                className='setting_section_main_container'
                sx={{ border: `1px solid ${theme.palette.artisticStroke200.main}`, minHeight: "260px" }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {/* codes to review section */}
                    {/* <Box> */}
                    <Typography className="setting_section_input_label">Codes to Review {ASTERISK_ELEMENT}</Typography>
                    <CheckboxGroup
                        fields={codeCheckboxes}
                        values={cqaConfig as { [key: string]: boolean }}
                        onChange={(field, checked) => {
                            const newConfig = { ...cqaConfig };
                            newConfig[field] = checked;
                            setCqaConfig(newConfig);
                        }}
                        stylesBox={{ gap: "24px", marginLeft: "2px" }}
                        stylesCheckbox={SELECTION_COLOR}
                    />
                </Box>

                {/* attributes section - hidden when rubric is assigned */}
                {!selectedRubricId && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Typography className="setting_section_input_label">Attributes</Typography>
                        <CheckboxGroup
                            fields={attributeCheckboxes}
                            values={cqaConfig as { [key: string]: boolean }}
                            onChange={(field, checked) => {
                                const newConfig = { ...cqaConfig };
                                newConfig[field] = checked;
                                setCqaConfig(newConfig);
                            }}
                            stylesBox={{ marginLeft: "2px" }}
                        />
                    </Box>
                )}

                {/* collection level section */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Typography className="setting_section_input_label">Collection Level</Typography>
                    <FormControl>
                        <RadioGroup
                            data-testid="caseEvalRadioGroup"
                            onChange={onChangeCaseEvaluation}
                            name="caseEvalRadioGroup"
                            row
                            sx={{ gap: "24px" }}
                            value={cqaConfig["caseEvaluationLevel"] === true ? "case" : "transaction"}
                        >
                            <FormControlLabel
                                data-testid="radioLabelCaseEval"
                                value={"case"}
                                control={<Radio sx={SELECTION_COLOR} />}
                                label="Case"
                            />
                            <FormControlLabel
                                data-testid="radioLabelTxEval"
                                value={"transaction"}
                                control={<Radio sx={SELECTION_COLOR} />}
                                label="Transaction"
                            />
                        </RadioGroup>
                    </FormControl>
                </Box>

                {/* features section */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {
                        spanAnnotationEnabled && (
                            <Box>
                                <Typography className="setting_section_input_label">Features</Typography>
                                <Grid container gap={"4px"} width={"586px"}>
                                    <Stack direction={"row"} sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
                                        <Typography className="setting_section_input_label" sx={{ color: "black" }}>Annotations</Typography>
                                        <Switch
                                            data-testid="spanAnnotationEnabled"
                                            checked={Boolean(cqaConfig.spanAnnotationEnabled)}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                const newConfig = { ...cqaConfig };
                                                newConfig["spanAnnotationEnabled"] = event.target.checked;
                                                setCqaConfig(newConfig);
                                            }}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: theme.palette.artisticGrey300.main,
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: theme.palette.artisticGrey300.main,
                                                },
                                            }}
                                        />
                                    </Stack>
                                </Grid>
                            </Box>
                        )
                    }
                </Box>
                {/* </Box> */}
            </Box >
        </Box>
    );
}